import type { ModuleStorage } from "app/pages/sales-intelligence/services/storage/types";

export default function createAccountReviewStorage(storageProvider: ModuleStorage) {
    const HAS_WEBSITE_SECTION_OPENED = "has-website-section-opened";
    const OPENED_WEBSITE_GROUPS = "opened-website-groups";

    const ownStorage = {
        getIsWebsiteSectionOpened() {
            return storageProvider.retrieve(HAS_WEBSITE_SECTION_OPENED) as boolean | undefined;
        },
        setIsWebsiteSectionOpened(isOpened: boolean) {
            storageProvider.persist(HAS_WEBSITE_SECTION_OPENED, isOpened);
        },
        getOpenedWebsiteGroups() {
            const openedGroups = storageProvider.retrieve(OPENED_WEBSITE_GROUPS);
            return Array.isArray(openedGroups) ? new Set(openedGroups) : new Set();
        },
        isWebsiteGroupOpened(id: string) {
            const openedGroups = this.getOpenedWebsiteGroups();
            return openedGroups.has(id);
        },
        updateOpenedWebsiteGroups(id: string, isOpened: boolean) {
            const openedGroups = this.getOpenedWebsiteGroups();
            if (isOpened) {
                openedGroups.add(id);
            } else {
                openedGroups.delete(id);
            }
            storageProvider.persist(OPENED_WEBSITE_GROUPS, Array.from(openedGroups));
        },
    };

    return ownStorage;
}
